import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {read, setGameConfig} from "@/assets/ts/utils";

// 判断存档是否存在

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

if (read() == undefined) {
  setGameConfig();
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})